import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import cookies from 'browser-cookies'

const COOKIE_NAME = "HITSTOM_LEGAL_ACCEPTED"
const COOKIE_VALUE = "TRUE"

export const hideLegalDialog = createActionCreator(actions.HIDE_LEGAL_DIALOG)

export const hideLegalDialogIfAccepted = () => (dispatch) => {
	if (cookies.get(COOKIE_NAME) === COOKIE_VALUE) {
		dispatch(acceptLegalDialog())
	}
}

export const acceptLegalDialog = () => (dispatch) => {
	cookies.set(COOKIE_NAME, COOKIE_VALUE)
	dispatch(hideLegalDialog())
	window._paq.push(['setConsentGiven']);
	window._paq.push(['trackPageView'])
}

export const cancelLegalDialog = () => (dispatch) => {		
	dispatch(hideLegalDialog())
	window._paq.push(['requireConsent'])	
}


// WEBPACK FOOTER //
// ./src/actionCreators/legalDialog.js